import React from "react";

const AdminSocialMediaField = (props) => {
    const {label, icon, value} = props;
    return (
        <div className="social-media-field">
            <div className="social-label">
                <div className={`icon-${icon}`}></div><span>{label}</span>
            </div>
            <input type="text" placeholder="Enter URL" value={value} onChange={(e) => props.handleInputChange(e, label.toLowerCase())}/>
        </div>
    )
}

export default AdminSocialMediaField


// WEBPACK FOOTER //
// ./src/components/admin/social-media/AdminSocialMediaField.js